<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead" id="contents"><a id="pagev" title="v">Contents</a></h1><a id="pagev" title="v">
</a><h2 class="tocfm"><a id="pagev" title="v"></a><a href="#/xhtml/05_Acknowledgement#ack"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="tocch"><a href="#/xhtml/06_Chapter01#chap1"><span class="tocnum"><span class="bold">Chapter 1</span></span> ‘Death is Lighter than a Feather’</a></h2>
<h2 class="tocch"><span href="#/xhtml/07_Chapter02#chap2" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 2</span></span> Desperate Measures</span></h2>
<h2 class="tocch"><span href="#/xhtml/08_Chapter03#chap3" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 3</span></span> ‘A Splendid Opportunity to Die’</span></h2>
<h2 class="tocch"><span href="#/xhtml/09_Chapter04#chap4" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 4</span></span> The Fall of the Philippines</span></h2>
<h2 class="tocch"><span href="#/xhtml/10_Chapter05#chap5" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 5</span></span> Developments and Defences</span></h2>
<h2 class="tocch"><span href="#/xhtml/11_Chapter06#chap6" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 6</span></span> Floating Chrysanthemum</span></h2>
<h2 class="tocch"><span href="#/xhtml/12_Chapter07#chap7" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 7</span></span> The Fall of Okinawa</span></h2>
<h2 class="tocch"><span href="#/xhtml/13_Chapter08#chap8" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 8</span></span> ‘To Bear the Unbearable’</span></h2>
<h2 class="tocch"><span href="#/xhtml/14_Chapter09#chap9" title="Link target outside of Sample"><span class="tocnum"><span class="bold">Chapter 9</span></span> ‘The Moon Rose Radiant’</span></h2>
<h2 class="tocbm"><span href="#/xhtml/15_Bibliography#bib" title="Link target outside of Sample"><em class="italic">Bibliography</em></span><a id="pagevi" title="vi"></a></h2><a id="pagevi" title="vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_toc.vue?4ac7afed